var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('vue-apex-charts',{ref:"newscolumnchart",staticClass:"newscolchart",attrs:{"type":"bar","height":_vm.colChartHeight,"options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }